import React from "react";

import logo from "../../assets/logo.svg";

import './styles.scss';

const Hero = () => (
  <div className="text-center hero my-5">
    <img
      className="mb-3 app-logo"
      src={logo}
      alt="Home Plant Tracker logo"
      width="120"
    />
    <h1 className="mb-4 title">
      Track Your Home Plants With Ease
    </h1>
  </div>
);

export default Hero;
